export enum HttpStatus {
  ContentTooLarge = 413,
  BadRequest = 400,
}
